import { render, staticRenderFns } from "./CargoAddNew.vue?vue&type=template&id=8e28c6ca&scoped=true&"
import script from "./CargoAddNew.vue?vue&type=script&lang=js&"
export * from "./CargoAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CargoAddNew.vue?vue&type=style&index=0&id=8e28c6ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e28c6ca",
  null
  
)

export default component.exports